import React from "react";
import NotebookAddMenu from "./NotebookAddMenu";
import LessonWizard from "./LessonWizard";
import ChapterHeader from "./ChapterHeader";
import LessonRow from "./LessonRow";

const NotebookTOC = ({
    notebookPages,
    groupedPages,

    expandedChapters,
    setExpandedChapters,
    toggleChapter,

    activeNotebookPageId,

    editingPageId,
    editingPageTitle,
    setEditingPageTitle,

    editingChapterTitle,
    setEditingChapterTitle,

    editingSectionTitle,
    setEditingSectionTitle,

    openNotebookPage,
    startEditingPage,
    saveEditingPage,
    cancelEditingPage,
    deleteNotebookPage,

    notebookPagesStorageKey,
    chapterNames,
    moveNotebookPage,
    setNotebookPages,

    isAddMenuOpen,
    setIsAddMenuOpen,

    setNewPageType,

    lessonDraftTitle,
    setLessonDraftTitle,

    lessonDraftChapter,
    setLessonDraftChapter,

    lessonDraftSection,
    setLessonDraftSection,

    lessonDraftNumber,
    setLessonDraftNumber,

    isChapterWizardOpen,
    setIsChapterWizardOpen,

    chapterDraftName,
    setChapterDraftName,

    notebookChapters,
    saveNotebookChapters,

    isLessonWizardOpen,
    setIsLessonWizardOpen,

    createNotebookPage,

    setActiveNotebookPageId,
    onNotesChange,
}) => {
    const [
        isTOCOpen,
        setIsTOCOpen,
    ] = React.useState(true);
    const [
        draggedChapterName,
        setDraggedChapterName,
    ] = React.useState(null);
    const [
        draggedLessonId,
        setDraggedLessonId,
    ] = React.useState(null);
    const [
        activeLessonDropChapter,
        setActiveLessonDropChapter,
    ] = React.useState(null);
    const [
        lessonInsertTargetId,
        setLessonInsertTargetId,
    ] = React.useState(null);
    const [
        isFullTOCOpen,
        setIsFullTOCOpen,
    ] = React.useState(false);
    const [
        tocNotice,
        setTocNotice,
    ] = React.useState("");
        React.useEffect(() => {
            if (!tocNotice) {
                return;
            }

            const timer =
                window.setTimeout(() => {
                    setTocNotice("");
                }, 2200);

            return () =>
                window.clearTimeout(timer);
        }, [tocNotice]);
        const handleOpenNotebookPage = (
            page
        ) => {
            openNotebookPage(
                page
            );

            const chapterName =
                page.chapterTitle?.trim() ||
                "Unassigned";

            const lessonLabel =
                page.lessonNumber
                    ? `Lesson ${page.lessonNumber} · `
                    : "";

            setTocNotice(
                `Lesson selected: ${chapterName} · ${lessonLabel}${
                    page.title ||
                    "Untitled Lesson"
                }`
            );

            setIsTOCOpen(false);
        };
    const activeNotebookPage =
        notebookPages.find(
            (page) =>
                page.id ===
                activeNotebookPageId
        ) || null;

    const activeChapterName =
        activeNotebookPage?.chapterTitle?.trim() ||
        "";

    const activeLessonName =
        activeNotebookPage?.title?.trim() ||
        "";

    const activeLessonNumber =
        activeNotebookPage?.lessonNumber ||
        null;
    const [
        tocSearch,
        setTocSearch,
    ] = React.useState("");

    const [
        tocFilter,
        setTocFilter,
    ] = React.useState("all");

    const normalizedTOCSearch =
        tocSearch.trim().toLowerCase();

    const filteredChapterNames =
        chapterNames.filter(
            (chapterName) => {
                if (!normalizedTOCSearch) {
                    return true;
                }

                const chapterMatch =
                    chapterName
                        .toLowerCase()
                        .includes(
                            normalizedTOCSearch
                        );

                const chapterPages =
                    groupedPages[
                        chapterName
                    ] || [];

                const pageMatch =
                    chapterPages.some(
                        (page) => {
                            const title =
                                page.title || "";

                            const section =
                                page.sectionTitle ||
                                "";

                            const content =
                                page.content || "";

                            return [
                                title,
                                section,
                                content,
                            ].some(
                                (value) =>
                                    value
                                        .toLowerCase()
                                        .includes(
                                            normalizedTOCSearch
                                        )
                            );
                        }
                    );

                if (
                    tocFilter ===
                    "chapters"
                ) {
                    return chapterMatch;
                }

                if (
                    tocFilter ===
                    "lessons"
                ) {
                    return chapterPages.some(
                        (page) =>
                            (
                                page.title ||
                                ""
                            )
                                .toLowerCase()
                                .includes(
                                    normalizedTOCSearch
                                )
                    );
                }

                if (
                    tocFilter ===
                    "notes"
                ) {
                    return chapterPages.some(
                        (page) =>
                            (
                                page.content ||
                                ""
                            )
                                .toLowerCase()
                                .includes(
                                    normalizedTOCSearch
                                )
                    );
                }

                return (
                    chapterMatch ||
                    pageMatch
                );
            }
        );

    const getFilteredChapterPages = (
        chapterName
    ) => {
        const chapterPages =
            groupedPages[
                chapterName
            ] || [];

        if (!normalizedTOCSearch) {
            return chapterPages;
        }

        if (
            tocFilter ===
            "chapters"
        ) {
            return chapterPages;
        }

        return chapterPages.filter(
            (page) => {
                const title =
                    (
                        page.title ||
                        ""
                    ).toLowerCase();

                const section =
                    (
                        page.sectionTitle ||
                        ""
                    ).toLowerCase();

                const content =
                    (
                        page.content ||
                        ""
                    ).toLowerCase();

                if (
                    tocFilter ===
                    "lessons"
                ) {
                    return title.includes(
                        normalizedTOCSearch
                    );
                }

                if (
                    tocFilter ===
                    "notes"
                ) {
                    return content.includes(
                        normalizedTOCSearch
                    );
                }

                return (
                    title.includes(
                        normalizedTOCSearch
                    ) ||
                    section.includes(
                        normalizedTOCSearch
                    ) ||
                    content.includes(
                        normalizedTOCSearch
                    )
                );
            }
        );
    };
const getSearchMatchSnippet = (
    page
) => {
    if (!normalizedTOCSearch) {
        return "";
    }

    const plainContent =
        (page.content || "")
            .replace(/<[^>]*>/g, " ")
            .replace(/&nbsp;/g, " ")
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/\s+/g, " ")
            .trim();

    const candidates = [
        page.sectionTitle || "",
        plainContent,
    ];

    for (const value of candidates) {
        const lowerValue =
            value.toLowerCase();

        const matchIndex =
            lowerValue.indexOf(
                normalizedTOCSearch
            );

        if (matchIndex === -1) {
            continue;
        }

        const start =
            Math.max(
                0,
                matchIndex - 45
            );

        const end =
            Math.min(
                value.length,
                matchIndex +
                    normalizedTOCSearch.length +
                    70
            );

        const snippet =
            value.slice(
                start,
                end
            );

        return `${
            start > 0 ? "…" : ""
        }${snippet}${
            end < value.length
                ? "…"
                : ""
        }`;
    }

    return "";
};

const highlightSearchMatch = (
    text
) => {
    if (
        !text ||
        !normalizedTOCSearch
    ) {
        return text;
    }

    const lowerText =
        text.toLowerCase();

    const matchIndex =
        lowerText.indexOf(
            normalizedTOCSearch
        );

    if (matchIndex === -1) {
        return text;
    }

    const before =
        text.slice(
            0,
            matchIndex
        );

    const match =
        text.slice(
            matchIndex,
            matchIndex +
                normalizedTOCSearch.length
        );

    const after =
        text.slice(
            matchIndex +
                normalizedTOCSearch.length
        );

    return (
        <>
            {before}

            <span
                className="
                    rounded
                    bg-[#ffd166]/20
                    px-0.5
                    font-semibold
                    text-[#ffd166]
                "
            >
                {match}
            </span>

            {after}
        </>
    );
};
const moveChapterToPosition = (
    targetChapterName
) => {
    if (
        !draggedChapterName ||
        draggedChapterName ===
            targetChapterName
    ) {
        setDraggedChapterName(
            null
        );

        return;
    }

    const orderedChapters = [
        ...chapterNames,
    ];

    const fromIndex =
        orderedChapters.indexOf(
            draggedChapterName
        );

    const toIndex =
        orderedChapters.indexOf(
            targetChapterName
        );

    if (
        fromIndex === -1 ||
        toIndex === -1
    ) {
        setDraggedChapterName(
            null
        );

        return;
    }

    const [
        movedChapter,
    ] = orderedChapters.splice(
        fromIndex,
        1
    );

    orderedChapters.splice(
        toIndex,
        0,
        movedChapter
    );

    saveNotebookChapters(
        orderedChapters
    );

    setDraggedChapterName(
        null
    );

    setTocNotice(
        `Chapter moved: ${movedChapter}`
    );
};

const moveLessonWithinChapter = (
    targetLessonId,
    chapterName
) => {
    if (
        !draggedLessonId ||
        draggedLessonId ===
            targetLessonId
    ) {
        setDraggedLessonId(
            null
        );

        return;
    }

    const chapterPages =
        notebookPages.filter(
            (page) =>
                (
                    page.chapterTitle?.trim() ||
                    "Unassigned"
                ) === chapterName
        );

    const fromIndex =
        chapterPages.findIndex(
            (page) =>
                page.id ===
                draggedLessonId
        );

    const toIndex =
        chapterPages.findIndex(
            (page) =>
                page.id ===
                targetLessonId
        );

    if (
        fromIndex === -1 ||
        toIndex === -1
    ) {
        setDraggedLessonId(
            null
        );

        return;
    }

    const reorderedChapterPages = [
        ...chapterPages,
    ];

    const [movedPage] =
        reorderedChapterPages.splice(
            fromIndex,
            1
        );

    reorderedChapterPages.splice(
        toIndex,
        0,
        movedPage
    );

    const reorderedIds =
        reorderedChapterPages.map(
            (page) => page.id
        );

    let chapterIndex = 0;

    const updatedPages =
        notebookPages.map(
            (page) => {
                const pageChapter =
                    page.chapterTitle?.trim() ||
                    "Unassigned";

                if (
                    pageChapter !==
                    chapterName
                ) {
                    return page;
                }

                const nextId =
                    reorderedIds[
                        chapterIndex
                    ];

                chapterIndex += 1;

                return (
                    reorderedChapterPages.find(
                        (chapterPage) =>
                            chapterPage.id ===
                            nextId
                    ) || page
                );
            }
        );

    setNotebookPages(
        updatedPages
    );

    try {
        localStorage.setItem(
            notebookPagesStorageKey,
            JSON.stringify(
                updatedPages
            )
        );
    } catch (error) {
        console.error(
            "Unable to reorder lessons:",
            error
        );
    }

    setDraggedLessonId(
        null
    );

    setTocNotice(
        `Lesson moved within ${chapterName}`
    );
};
    return (
        <>
    {tocNotice && (
        <div
            className="
                fixed
                left-1/2
                top-6
                z-[100000]
                -translate-x-1/2
                rounded-2xl
                border
                border-[#ffd166]/45
                bg-[#05070d]/95
                px-4
                py-3
                shadow-[0_0_30px_rgba(255,209,102,0.18)]
                backdrop-blur-sm
            "
        >
            <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-[#d8b4fe]">
                Table of Contents
            </p>

            <p className="mt-1 text-sm font-semibold text-[#fff3c4]">
                {tocNotice}
            </p>
        </div>
    )}
    <div className="mb-3 rounded-2xl border border-[#ffd166]/20 bg-black/40 p-3">
        <div className="flex items-center justify-between gap-2">
            <button
                type="button"
                onClick={() =>
                    setIsTOCOpen(
                        (current) =>
                            !current
                    )
                }
                className="
                    flex
                    min-w-0
                    flex-1
                    items-center
                    justify-between
                    gap-3
                    text-left
                "
            >
                <div className="min-w-0">
                    <p className="text-[10px] uppercase tracking-[0.18em] text-[#d8b4fe]">
                        Table of Contents
                    </p>

                    {!isTOCOpen &&
                    activeNotebookPage ? (
                        <p className="mt-1 text-xs text-[#b0b8d6]">
                            Working on {" "}
                            <span className="font-semibold text-[#ffd166]">
                                {activeChapterName ||
                                    "Unassigned"}
                            </span>

                            {activeLessonNumber && (
                                <>
                                    {" "}
                                    · Lesson{" "}
                                    {activeLessonNumber}
                                </>
                            )}

                            {activeLessonName && (
                                <>
                                    {" "}
                                    ·{" "}
                                    <span className="text-[#fff3c4]">
                                        {activeLessonName}
                                    </span>
                                </>
                            )}
                        </p>
                    ) : (
                        <p className="mt-1 text-xs text-[#b0b8d6]">
                            Chapters, lessons,
                            sections, and topics.
                        </p>
                    )}
                </div>

                <span className="shrink-0 text-xs text-[#ffd166]">
                    {isTOCOpen
                        ? "▼"
                        : "▶"}
                </span>
            </button>

            
        </div>

        {isTOCOpen && (
            <>
                <div className="mt-3 flex justify-end">
                <NotebookAddMenu
                    isAddMenuOpen={
                        isAddMenuOpen
                    }
                    setIsAddMenuOpen={
                        setIsAddMenuOpen
                    }

                    notebookPages={
                        notebookPages
                    }

                    setNewPageType={
                        setNewPageType
                    }

                    setLessonDraftTitle={
                        setLessonDraftTitle
                    }
                    setLessonDraftChapter={
                        setLessonDraftChapter
                    }
                    setLessonDraftSection={
                        setLessonDraftSection
                    }
                    setLessonDraftNumber={
                        setLessonDraftNumber
                    }

                    setIsChapterWizardOpen={
                        setIsChapterWizardOpen
                    }

                    setIsLessonWizardOpen={
                        setIsLessonWizardOpen
                    }

                    createNotebookPage={
                        createNotebookPage
                    }
                />
            </div>
                {isChapterWizardOpen && (
                    <div
                        className="
                            mt-3
                            rounded-2xl
                            border
                            border-[#ffd166]/25
                            bg-[#05070d]
                            p-4
                            shadow-[0_0_24px_rgba(255,209,102,0.10)]
                        "
                    >
                        <div className="mb-3">
                            <p className="text-[10px] uppercase tracking-[0.18em] text-[#d8b4fe]">
                                New Chapter
                            </p>

                            <p className="mt-1 text-xs text-[#b0b8d6]">
                                Create a chapter before adding lessons.
                            </p>
                        </div>

                        <label className="mb-1 block text-[10px] font-semibold uppercase tracking-[0.14em] text-[#ffd166]">
                            Chapter Name
                        </label>

                        <input
                            type="text"
                            value={
                                chapterDraftName
                            }
                            onChange={(event) =>
                                setChapterDraftName(
                                    event.target.value
                                )
                            }
                            placeholder="Example: Chapter 1 · Ancient Egypt"
                            className="
                                w-full
                                rounded-xl
                                border
                                border-[#ffd166]/30
                                bg-[#080b14]
                                px-3
                                py-2
                                text-sm
                                text-[#fff3c4]
                                outline-none
                                placeholder:text-[#6c7a9c]
                                focus:border-[#ffd166]
                            "
                        />

                        <div className="mt-4 flex justify-end gap-2">
                            <button
                                type="button"
                                onClick={() => {
                                    setChapterDraftName(
                                        ""
                                    );

                                    setIsChapterWizardOpen(
                                        false
                                    );
                                }}
                                className="
                                    rounded-xl
                                    border
                                    border-[#c084fc]/30
                                    bg-black
                                    px-3
                                    py-2
                                    text-xs
                                    text-[#d8b4fe]
                                    transition
                                    hover:border-[#c084fc]/70
                                "
                            >
                                Cancel
                            </button>

                            <button
                                type="button"
                                onClick={() => {
                                    const cleanName =
                                        chapterDraftName.trim();

                                    if (!cleanName) {
                                        return;
                                    }

                                    const alreadyExists =
                                        notebookChapters.some(
                                            (
                                                chapterName
                                            ) =>
                                                chapterName.toLowerCase() ===
                                                cleanName.toLowerCase()
                                        );

                                    if (
                                        !alreadyExists
                                    ) {
                                        saveNotebookChapters(
                                            [
                                                ...notebookChapters,
                                                cleanName,
                                            ]
                                        );
                                    }

                                    setExpandedChapters(
                                        (current) => ({
                                            ...current,
                                            [cleanName]:
                                                true,
                                        })
                                    );

                                    setChapterDraftName(
                                        ""
                                    );

                                    setIsChapterWizardOpen(
                                        false
                                    );
                                }}
                                className="
                                    rounded-xl
                                    border
                                    border-[#ffd166]/50
                                    bg-[#2b1548]/80
                                    px-4
                                    py-2
                                    text-xs
                                    font-semibold
                                    text-[#ffd166]
                                    transition
                                    hover:border-[#ffd166]
                                    hover:bg-[#ffd166]/10
                                "
                            >
                                Create Chapter
                            </button>
                        </div>
                    </div>
                )}

                {isLessonWizardOpen && (
                    <LessonWizard
                        lessonDraftTitle={
                            lessonDraftTitle
                        }
                        setLessonDraftTitle={
                            setLessonDraftTitle
                        }

                        lessonDraftChapter={
                            lessonDraftChapter
                        }
                        setLessonDraftChapter={
                            setLessonDraftChapter
                        }

                        lessonDraftSection={
                            lessonDraftSection
                        }
                        setLessonDraftSection={
                            setLessonDraftSection
                        }

                        lessonDraftNumber={
                            lessonDraftNumber
                        }
                        setLessonDraftNumber={
                            setLessonDraftNumber
                        }

                        notebookPages={
                            notebookPages
                        }
                        setNotebookPages={
                            setNotebookPages
                        }

                        notebookPagesStorageKey={
                            notebookPagesStorageKey
                        }

                        setActiveNotebookPageId={
                            setActiveNotebookPageId
                        }
                        onNotesChange={
                            onNotesChange
                        }

                        setExpandedChapters={
                            setExpandedChapters
                        }

                        chapterNames={
                            chapterNames
                        }
                        setIsChapterWizardOpen={
                            setIsChapterWizardOpen
                        }

                        notebookChapters={
                            notebookChapters
                        }
                        saveNotebookChapters={
                            saveNotebookChapters
                        }

                        setIsLessonWizardOpen={
                            setIsLessonWizardOpen
                        }
                    />
                )}

                {chapterNames.length ===
                0 ? (
                    <div className="mt-3 rounded-xl border border-[#ffd166]/15 bg-[#080b14] p-3">
                        <p className="text-xs text-[#7f8baa]">
                            No chapters yet.
                            Use + Add to create
                            your first chapter or
                            lesson.
                        </p>
                    </div>
                ) : (
                    <div className="mt-3 max-h-[210px] space-y-2 overflow-y-auto pr-1">
                        {chapterNames.map(
                            (
                                chapterName
                            ) => {
                                const chapterPages =
                                    groupedPages[
                                        chapterName
                                    ] || [];

                                const isChapterOpen =
                                    expandedChapters[
                                        chapterName
                                    ] !==
                                    false;

                                return (
                                    <div
                                        key={
                                            chapterName
                                        }
                                        draggable
                                        onDragStart={() =>
                                            setDraggedChapterName(
                                                chapterName
                                            )
                                        }
                                        onDragEnd={() =>
                                            setDraggedChapterName(
                                                null
                                            )
                                        }
                                        onDrop={(event) => {
                                            event.preventDefault();

                                            if (draggedLessonId) {
                                                moveNotebookPage(
                                                    draggedLessonId,
                                                    chapterName
                                                );

                                                setDraggedLessonId(
                                                    null
                                                );

                                                setTocNotice(
                                                    `Lesson moved to ${chapterName}`
                                                );

                                                setExpandedChapters(
                                                    (current) => ({
                                                        ...current,
                                                        [chapterName]: true,
                                                    })
                                                );

                                                return;
                                            }

                                            if (draggedChapterName) {
                                                moveChapterToPosition(
                                                    chapterName
                                                );
                                            }
                                        }}
                                        className={`
                                            overflow-hidden
                                            rounded-xl
                                            border
                                            bg-[#080b14]
                                            transition
                                            ${
                                                draggedChapterName ===
                                                chapterName
                                                    ? "border-[#ffd166] opacity-60"
                                                    : "border-[#ffd166]/20"
                                            }
                                        `}
                                    >
                                    <div
                                        className="
                                            flex
                                            cursor-grab
                                            items-center
                                            gap-2
                                            border-b
                                            border-[#ffd166]/10
                                            bg-black/25
                                            px-3
                                            py-1
                                            text-[9px]
                                            uppercase
                                            tracking-[0.14em]
                                            text-[#8f98b5]
                                            active:cursor-grabbing
                                        "
                                        title="Drag chapter to reorder"
                                    >
                                        <span>
                                            ⋮⋮
                                        </span>

                                        <span>
                                            Drag to reorder
                                        </span>
                                    </div>
                                        <ChapterHeader
                                            chapterName={
                                                chapterName
                                            }
                                            chapterPages={
                                                chapterPages
                                            }
                                            isChapterOpen={
                                                isChapterOpen
                                            }
                                            toggleChapter={
                                                toggleChapter
                                            }

                                            notebookPages={
                                                notebookPages
                                            }
                                            setNotebookPages={
                                                setNotebookPages
                                            }
                                            notebookPagesStorageKey={
                                                notebookPagesStorageKey
                                            }

                                            setExpandedChapters={
                                                setExpandedChapters
                                            }

                                            notebookChapters={
                                                notebookChapters
                                            }
                                            saveNotebookChapters={
                                                saveNotebookChapters
                                            }
                                        />

                                        {isChapterOpen && (
                                            <div className="space-y-1.5 border-t border-[#ffd166]/15 p-2">
                                                {chapterPages.length ===
                                                0 ? (
                                                    <p className="px-2 py-2 text-xs text-[#7f8baa]">
                                                        No lessons in this chapter yet.
                                                    </p>
                                                ) : (
                                                    chapterPages.map(
                                                        (
                                                            page,
                                                            index
                                                        ) => (
                                                            <LessonRow
                                                                key={
                                                                    page.id
                                                                }
                                                                page={
                                                                    page
                                                                }
                                                                index={
                                                                    index
                                                                }

                                                                activeNotebookPageId={
                                                                    activeNotebookPageId
                                                                }

                                                                editingPageId={
                                                                    editingPageId
                                                                }
                                                                editingPageTitle={
                                                                    editingPageTitle
                                                                }
                                                                setEditingPageTitle={
                                                                    setEditingPageTitle
                                                                }

                                                                editingChapterTitle={
                                                                    editingChapterTitle
                                                                }
                                                                setEditingChapterTitle={
                                                                    setEditingChapterTitle
                                                                }

                                                                editingSectionTitle={
                                                                    editingSectionTitle
                                                                }
                                                                setEditingSectionTitle={
                                                                    setEditingSectionTitle
                                                                }

                                                                openNotebookPage={
                                                                    handleOpenNotebookPage
                                                                }
                                                                startEditingPage={
                                                                    startEditingPage
                                                                }
                                                                saveEditingPage={
                                                                    saveEditingPage
                                                                }
                                                                cancelEditingPage={
                                                                    cancelEditingPage
                                                                }
                                                                deleteNotebookPage={
                                                                    deleteNotebookPage
                                                                }

                                                                chapterNames={
                                                                    chapterNames
                                                                }
                                                                moveNotebookPage={
                                                                    moveNotebookPage
                                                                
                                                                }
                                                                draggedLessonId={
                                                                    draggedLessonId
                                                                }
                                                                setDraggedLessonId={
                                                                    setDraggedLessonId
                                                                }
                                                                moveLessonWithinChapter={
                                                                    moveLessonWithinChapter
                                                                }
                                                            />
                                                        )
                                                    )
                                                )}
                                            </div>
                                        )}
                                    </div>
                                );
                            }
                        )}
                    </div>
                )}
                <div className="mt-3 flex justify-end">
                    <button
                        type="button"
                        onClick={() =>
                            setIsFullTOCOpen(
                                true
                            )
                        }
                        className="
                            rounded-xl
                            border
                            border-[#ffd166]/35
                            bg-black
                            px-3
                            py-2
                            text-xs
                            font-semibold
                            text-[#ffd166]
                            transition
                            hover:border-[#ffd166]
                            hover:bg-[#ffd166]/10
                        "
                    >
                        View Full TOC
                    </button>
                </div>
            </>
        )}
    </div>
    {isFullTOCOpen && (
        <div
            className="
                fixed
                inset-0
                z-[99999]
                flex
                items-center
                justify-center
                bg-black/85
                px-4
                py-6
                backdrop-blur-sm
            "
        >
            <div
                className="
                    flex
                    max-h-[88vh]
                    w-full
                    max-w-5xl
                    flex-col
                    overflow-hidden
                    rounded-[32px]
                    border
                    border-[#ffd166]/45
                    bg-[#05070d]
                    shadow-[0_0_48px_rgba(255,209,102,0.18)]
                "
            >
                <div
                    className="
                        flex
                        shrink-0
                        items-center
                        justify-between
                        gap-3
                        border-b
                        border-[#ffd166]/20
                        bg-black/80
                        px-5
                        py-4
                    "
                >
                    <div>
                        <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#d8b4fe]">
                            Liberi Curiosi
                        </p>

                        <h3 className="mt-1 font-display text-2xl text-[#ffd166]">
                            Full Table of Contents
                        </h3>
                    </div>

                    <button
                        type="button"
                        onClick={() =>
                            setIsFullTOCOpen(
                                false
                            )
                        }
                        className="
                            rounded-xl
                            border
                            border-[#c084fc]/30
                            bg-black
                            px-3
                            py-2
                            text-xs
                            font-semibold
                            text-[#d8b4fe]
                            transition
                            hover:border-[#ffd166]
                            hover:text-[#ffd166]
                        "
                    >
                        Close
                    </button>
                </div>
                <div
                    className="
                        shrink-0
                        border-b
                        border-[#ffd166]/15
                        bg-[#080b14]
                        px-5
                        py-4
                    "
                >
                    <input
                        type="text"
                        value={tocSearch}
                        onChange={(event) =>
                            setTocSearch(
                                event.target.value
                            )
                        }
                        placeholder="Search chapters, lessons, topics, and notes..."
                        className="
                            w-full
                            rounded-xl
                            border
                            border-[#ffd166]/30
                            bg-black
                            px-3
                            py-2.5
                            text-sm
                            text-[#fff3c4]
                            outline-none
                            placeholder:text-[#6c7a9c]
                            focus:border-[#ffd166]
                        "
                    />

                    <div className="mt-3 flex flex-wrap gap-2">
                        {[
                            ["all", "All"],
                            ["chapters", "Chapters"],
                            ["lessons", "Lessons"],
                            ["notes", "Notes"],
                        ].map(
                            ([value, label]) => (
                                <button
                                    key={value}
                                    type="button"
                                    onClick={() =>
                                        setTocFilter(
                                            value
                                        )
                                    }
                                    className={`
                                        rounded-lg
                                        border
                                        px-3
                                        py-1.5
                                        text-[10px]
                                        font-semibold
                                        transition
                                        ${
                                            tocFilter ===
                                            value
                                                ? "border-[#ffd166] bg-[#ffd166]/10 text-[#ffd166]"
                                                : "border-[#c084fc]/25 bg-black text-[#d8b4fe] hover:border-[#c084fc]/60"
                                        }
                                    `}
                                >
                                    {label}
                                </button>
                            )
                        )}
                    </div>
                </div>
                <div className="min-h-0 flex-1 overflow-y-auto p-5">
                    {filteredChapterNames.length ===
                    0 ? (
                        <div className="rounded-2xl border border-[#ffd166]/15 bg-[#080b14] p-4">
                            <p className="text-sm text-[#7f8baa]">
                                No chapters yet.
                            </p>
                        </div>
                    ) : (
                        <div className="space-y-3">
                            {filteredChapterNames.map(
                                (
                                    chapterName
                                ) => {
                                    const chapterPages =
                                        groupedPages[
                                            chapterName
                                        ] || [];

                                    return (
                                        <div
                                            key={
                                                chapterName
                                            }
                                            onDragOver={(event) => {
                                                if (draggedLessonId) {
                                                    event.preventDefault();

                                                    setActiveLessonDropChapter(
                                                        chapterName
                                                    );
                                                }
                                            }}
                                            onDragLeave={(event) => {
                                                if (
                                                    !event.currentTarget.contains(
                                                        event.relatedTarget
                                                    )
                                                ) {
                                                    setActiveLessonDropChapter(
                                                        null
                                                    );
                                                }
                                            }}
                                            onDrop={(event) => {
                                                if (!draggedLessonId) {
                                                    return;
                                                }

                                                event.preventDefault();

                                                moveNotebookPage(
                                                    draggedLessonId,
                                                    chapterName
                                                );

                                                setDraggedLessonId(
                                                    null
                                                );

                                                setActiveLessonDropChapter(
                                                    null
                                                );

                                                setTocNotice(
                                                    `Lesson moved to ${chapterName}`
                                                );

                                                setExpandedChapters(
                                                    (current) => ({
                                                        ...current,
                                                        [chapterName]: true,
                                                    })
                                                );
                                            }}
                                            className={`
                                                rounded-2xl
                                                border
                                                p-4
                                                transition
                                                ${
                                                    activeLessonDropChapter ===
                                                    chapterName
                                                        ? "border-[#ffd166] bg-[#ffd166]/10 shadow-[0_0_28px_rgba(255,209,102,0.18)]"
                                                        : "border-[#ffd166]/20 bg-[#080b14]"
                                                }
                                            `}
                                        >
                                            <div className="flex items-center justify-between gap-3">
                                                <div>
                                                    {activeLessonDropChapter ===
                                                        chapterName && (
                                                        <p
                                                            className="
                                                                mb-1
                                                                text-[10px]
                                                                font-semibold
                                                                uppercase
                                                                tracking-[0.18em]
                                                                text-[#ffd166]
                                                                animate-pulse
                                                            "
                                                        >
                                                            ✨ Drop Lesson Here
                                                        </p>
                                                    )}
                                                    <p className="text-sm font-semibold text-[#ffd166]">
                                                        {
                                                            chapterName
                                                        }
                                                    </p>

                                                    <p className="mt-1 text-[10px] text-[#8f98b5]">
                                                        {
                                                            chapterPages.length
                                                        }{" "}
                                                        lesson
                                                        {chapterPages.length ===
                                                        1
                                                            ? ""
                                                            : "s"}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="mt-3 space-y-1.5">
                                                {chapterPages.length ===
                                                0 ? (
                                                    <p className="text-xs text-[#7f8baa]">
                                                        No lessons yet.
                                                    </p>
                                                ) : (
                                                chapterPages.map(
                                                    (
                                                        page
                                                    ) => (
                                                        <div
                                                            key={
                                                                page.id
                                                            }
                                                        >
                                                            {lessonInsertTargetId ===
                                                                page.id &&
                                                                draggedLessonId !==
                                                                    page.id && (
                                                                <div
                                                                    className="
                                                                        mb-1
                                                                        flex
                                                                        items-center
                                                                        gap-2
                                                                    "
                                                                >
                                                                    <div className="h-px flex-1 bg-[#ffd166]" />

                                                                    <span className="text-[9px] font-semibold uppercase tracking-[0.14em] text-[#ffd166]">
                                                                        Drop here
                                                                    </span>

                                                                    <div className="h-px flex-1 bg-[#ffd166]" />
                                                                </div>
                                                            )}

                                                            <button
                                                                type="button"
                                                                draggable
                                                                onDragStart={(event) => {
                                                                    event.stopPropagation();

                                                                    setDraggedLessonId(
                                                                        page.id
                                                                    );
                                                                }}
                                                                onDragEnd={(event) => {
                                                                    event.stopPropagation();

                                                                    setDraggedLessonId(
                                                                        null
                                                                    );

                                                                    setLessonInsertTargetId(
                                                                        null
                                                                    );

                                                                    setActiveLessonDropChapter(
                                                                        null
                                                                    );
                                                                }}
                                                                onDragOver={(event) => {
                                                                    event.preventDefault();
                                                                    event.stopPropagation();

                                                                    setLessonInsertTargetId(
                                                                        page.id
                                                                    );
                                                                }}
                                                                onDrop={(event) => {
                                                                    event.preventDefault();
                                                                    event.stopPropagation();

                                                                    moveLessonWithinChapter(
                                                                        page.id,
                                                                        chapterName
                                                                    );

                                                                    setLessonInsertTargetId(
                                                                        null
                                                                    );

                                                                    setActiveLessonDropChapter(
                                                                        null
                                                                    );
                                                                }}
                                                                onClick={() => {
                                                                    handleOpenNotebookPage(
                                                                        page
                                                                    );

                                                                    setIsFullTOCOpen(
                                                                        false
                                                                    );
                                                                }}
                                                                className="
                                                                    block
                                                                    w-full
                                                                    rounded-xl
                                                                    border
                                                                    border-[#ffd166]/10
                                                                    bg-black/35
                                                                    px-3
                                                                    py-2.5
                                                                    text-left
                                                                    transition
                                                                    hover:border-[#c084fc]/40
                                                                    hover:bg-[#2b1548]/30
                                                                "
                                                            >
                                                                <p className="text-sm font-semibold text-[#fff3c4]">
                                                                    {page.title ||
                                                                        "Untitled Lesson"}
                                                                </p>

                                                                {page.sectionTitle && (
                                                                    <p className="mt-1 text-[10px] uppercase tracking-[0.14em] text-[#b0b8d6]">
                                                                        {
                                                                            page.sectionTitle
                                                                        }
                                                                    </p>
                                                                )}

                                                                {normalizedTOCSearch &&
                                                                getSearchMatchSnippet(
                                                                    page
                                                                ) && (
                                                                    <div
                                                                        className="
                                                                            mt-2
                                                                            rounded-lg
                                                                            border
                                                                            border-[#c084fc]/15
                                                                            bg-[#2b1548]/20
                                                                            px-2.5
                                                                            py-2
                                                                        "
                                                                    >
                                                                        <p className="text-[9px] font-semibold uppercase tracking-[0.14em] text-[#d8b4fe]">
                                                                            Match
                                                                        </p>

                                                                        <p className="mt-1 text-xs leading-5 text-[#b0b8d6]">
                                                                            {highlightSearchMatch(
                                                                                getSearchMatchSnippet(
                                                                                    page
                                                                                )
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                )}
                                                            </button>
                                                        </div>
                                                    
                                                        )
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    );
                                }
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )}
        </>
);
};

export default NotebookTOC;